export default __webpack_public_path__ + "static/media/Snd_C_Starts.16a18769.mp3";